// extracted by mini-css-extract-plugin
module.exports = {"container":"content-area_container__fpa9z"};